import { alpha, Theme } from "@mui/material";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  cardsGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(2, 1fr)",
    gap: "10px",
    width: "100%",
  },
  card: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    gap: "10px",
    boxSizing: "border-box",
    height: "99px",
    padding: "20px 24px",
    borderRadius: "6px",
    backgroundColor: theme.palette.common.white,
    width: "100%",
  },
  topRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  value: {
    fontFamily: "Noto Sans Hebrew",
    fontSize: "27.6px",
    fontWeight: 700,
    lineHeight: "100%",
    textAlign: "right",
    color: theme.palette.secondary.main,
  },
  label: {
    fontFamily: "Noto Sans Hebrew",
    fontSize: "13.8px",
    fontWeight: 400,
    lineHeight: "120%",
    textAlign: "center",
    alignSelf: "flex-end",
    color: "#6C7A7A",
  },
  phoneIcon: {
    width: "32px",
    height: "32px",
    borderRadius: "50%",
    backgroundColor: alpha(theme.palette.secondary.main, 0.06),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: theme.palette.text.secondary,
    "& svg": {
      fontSize: "18px",
    },
  },
}));
